export const INSTORE_SERVICES_LIST: string[] = ['2135', '3628', '2134', '3681', '2137', '2138', '2136', '2133'];

export const KZ_INSTORE_SERVICES_LIST: string[] = ['2134', '2137', '2136'];
